import { GENERIC, UNIVERSAL } from 'const/account/clients'

const isUniversalClient = (client: string) => {
  return [UNIVERSAL, GENERIC].includes(client)
}

export default isUniversalClient
